import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useMemo } from 'react';
import { permissions } from '../constants/permission';
import { rolePermissions } from '../constants/rolePermission';

var useRolePermission = function useRolePermission(roles) {
  var mergedPermissions = useMemo(function () {
    var permissionNames = new Map();
    roles.forEach(function (role) {
      var rolePermission = rolePermissions[role];

      if (rolePermission) {
        Object.entries(rolePermission).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              type = _ref2[0],
              names = _ref2[1];

          if (!permissionNames.has(type)) {
            permissionNames.set(type, new Set());
          }

          names === null || names === void 0 ? void 0 : names.forEach(function (name) {
            return permissionNames.get(type).add(name);
          });
        });
      }
    });
    var permissionObjects = new Map();
    permissionNames.forEach(function (names, type) {
      permissionObjects.set(type, permissions.filter(function (permission) {
        return names.has(permission.name) && permission.type === type;
      }));
    });
    return permissionObjects;
  }, [roles]);
  var can = useCallback(function (_ref3) {
    var type = _ref3.type,
        subject = _ref3.subject,
        action = _ref3.action,
        property = _ref3.property;
    var permissionsOfType = mergedPermissions.get(type);
    if (!permissionsOfType) return false;
    return permissionsOfType.some(function (permission) {
      if (type === 'page') {
        return permission.subject === subject;
      }

      if (type === 'data') {
        var dataPermission = permission;
        return dataPermission.subject === subject && dataPermission.action === action && (!property || dataPermission.property === property);
      }

      if (type === 'action') {
        var actionPermission = permission;
        return actionPermission.subject === subject && actionPermission.action === action;
      }

      return false;
    });
  }, [mergedPermissions]);
  return {
    can: can
  };
};

export default useRolePermission;